import styled from 'styled-components';

export const ImageUploadContainer = styled.div<{ $isFirstStep?: boolean; $isMobile?: boolean }>`
  ${({ $isFirstStep, $isMobile }) =>
    $isFirstStep &&
    !$isMobile &&
    `
    width: 75%;
    margin: 0 auto;
    
    & > div > .step-content-helper-text {
      text-align: center;
    }

    .title {
      text-align: center;
    }
  `}
  padding-top: ${({ theme: { token }, $isMobile }) => ($isMobile ? 0 : token.paddingXL)}px;
  padding-bottom: ${({ theme: { token } }) => token.padding}px;
  padding-left: ${({ theme: { token } }) => token.padding}px;
  padding-right: ${({ theme: { token } }) => token.padding}px;

  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }
`;
